import { ReturnInboundItem } from '@/services/return/returnInbound/types'

/**
 * 화면에서 거르는 조건들 — BE 가 받지 않아 여기가 유일한 적용 지점이다.
 * 받은 행(상한 1,000) 안에서만 거른다 — 결과를 줄이는 조건은 서버로 보내야 한다(입고일자, LOGISPRD-14906).
 */
export interface ClientFilter {
  /** 입고유형 — BE 는 `ordType = RETURN` 고정이라 하위 구분을 받지 않는다. */
  orderType?: string
  /** 목록 검색어(소문자). */
  keyword?: string
}

/** 목록 검색 — 행의 모든 값을 통으로 훑는다(1.0 ag-grid quickFilter 와 같은 어휘). */
export const matchesKeyword = (row: ReturnInboundItem, keyword: string): boolean =>
  Object.values(row).some((value) => String(value).toLowerCase().includes(keyword))

export const applyClientFilter = (rows: ReturnInboundItem[], { orderType, keyword }: ClientFilter): ReturnInboundItem[] => {
  let out = rows
  if (orderType) out = out.filter((row) => row.orderType === orderType)
  if (keyword) out = out.filter((row) => matchesKeyword(row, keyword))
  return out
}
